/* global eventHub */
/* eslint no-undef: "error" */
export default {
  data: function () {
    return {
      message: 'hello',
      foo: 'abc'
    }
  },
  created: function () {
    this.setTitle()
  },
  watch: {
    '$store.state.locale': function () {
      this.setTitle()
    }
  },
  methods: {
    setTitle: function () {
      eventHub.$emit('set-title', this.getTitle())
    },
    getTitle: function () {
      return 'Title missing'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/BaseCardMixin.js